import { $ } from '@/Engine/state';
import { computePointerPosition } from '@/Engine/eventHandlers/onMouseDownHandler';
import { IV3D } from '@/Interfaces/v3d';

declare let v3d: IV3D;
export const _raycaster = new v3d.Raycaster(new v3d.Vector3(0,0,0), new v3d.Vector3(0, 0, -10),  -10, 100);
export const plane = new v3d.Plane(new v3d.Vector3(0, 0, 1), 0);
export const getPointerCoords = () => {
    const intersect = new v3d.Vector3();
    return _raycaster.ray.intersectPlane(plane,intersect);
};
export const setRaycasterFromCamera = (event: MouseEvent|PointerEvent) => {
    //курсор в координатах сцены 1юнит = 1метр
    $.pointer.copy(computePointerPosition($.container, event));
    _raycaster.setFromCamera($.pointer, $.app.camera);
};
